// Resources
// Amplify
import { resendSignUpCode } from "aws-amplify/auth";

// Redux
import { openSnackbar } from "Store/SnackbarSlice";

export const handleResendCode = async ({ userEmail, dispatch, t }) => {
  try {
    await resendSignUpCode({ username: userEmail });
    dispatch(
      openSnackbar({
        message: t("confirmSignUp.resendSuccess"),
        severity: "success",
      })
    );
  } catch (error) {
    let errorMessage;

    switch (error.name) {
      case "LimitExceededException":
        errorMessage = t("errors.tooManyAttempts");
        break;
      case "UserNotFoundException":
        errorMessage = t("errors.userNotFound");
        break;
      default:
        errorMessage = error.message;
        break;
    }
    dispatch(openSnackbar({ message: errorMessage, severity: "error" }));
  }
};

